import { useEffect, useState } from "react";
import "./App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { RealDeviceSection } from "./components/RealDeviceSection";
import { FlexPilotSection } from "./components/FlexPilotSection";
import { ContactModal } from "./components/ContactModal";
import { BenefitsSection } from "./components/BenefisSecion";
import { IntegrationsSection } from "./components/IntegrationsSection";
import { LanguageProvider } from "./i18n/LanguageContext";

/** Прежнее имя секции «Для ресторанов»: она называлась `#investor`, пока
 * навигация звала инвестора. Ссылка `table-one.pro/#investor` уже разошлась по
 * переписке и презентациям, а якорь до сервера не доходит — редиректом его не
 * поймать. Поэтому старое имя переводится в новое здесь, на клиенте.
 */
const LEGACY_SECTION_HASH = "#investor";
const RESTAURANTS_SECTION_HASH = "#restaurants";

function App() {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    useEffect(() => {
        const redirectLegacyHash = () => {
            if (window.location.hash !== LEGACY_SECTION_HASH) return;
            window.history.replaceState(null, "", RESTAURANTS_SECTION_HASH);
            document.getElementById("restaurants")?.scrollIntoView();
        };

        redirectLegacyHash();
        window.addEventListener("hashchange", redirectLegacyHash);
        return () => window.removeEventListener("hashchange", redirectLegacyHash);
    }, []);

    const openContactModal = () => setIsContactModalOpen(true);
    const closeContactModal = () => setIsContactModalOpen(false);

    return (
        <LanguageProvider>
            <div className="app" id="top">
                <Header onOpenContactForm={openContactModal} />

                <main>
                    <HeroSection onOpenContactForm={openContactModal} />
                    <RealDeviceSection />
                    <BenefitsSection />
                    <IntegrationsSection />
                    <FlexPilotSection onOpenContactForm={openContactModal} />
                </main>

                <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
            </div>
        </LanguageProvider>
    );
}

export default App;
